<ion-card class="margin2px" style="margin-bottom: 5px;">
  <ion-card class="margin0 padding5">
    <ion-row>
      <ion-col size="2" class="textCenter">
        <img [src]="feed.creator.url" *ngIf="feed.creator && feed.creator.url">
        <ion-icon name="person-circle-outline" *ngIf="feed.creator && !feed.creator.url" class="font2"
          color="tertiary"></ion-icon>
      </ion-col>
      <ion-col size="10">
        <b  (click)="openDetails.emit('')">{{feed.header}}</b>
        <div class="font0_9 mediumColor" *ngIf="feed.creator">{{feed.creator.name}}({{feed.creator.role}})
          <span class="floatRight">{{feed.created_at | fancyDateOnly}}</span>
        </div>
      </ion-col>
    </ion-row>
  </ion-card>
  <div class="padding0 margin0" (click)="openDetails.emit('')">
    <swiper-container [loop]="true" autoplay="true" [pagination]="true" [zoom]="true" *ngIf="feed.image_urls">
      <swiper-slide *ngFor="let url of feed.image_urls">
        <img [src]="url"></swiper-slide>
    </swiper-container>

  </div>
  <div class="margin0 padding5" (click)="openDetails.emit('')">
    <div>{{feed.description}}</div>
    <div class="textRight">
      Event Date:
      <ion-badge color="primary" mode="ios">{{feed.event_date |
        fancyDateOnly}}</ion-badge>
    </div>
  </div>
  <ion-card class="margin0 padding5">
    <ion-row>
      <ion-col size="10" (click)="openDetails.emit('')">
        <span *ngIf="feed.reactionKeys">
          <span *ngFor="let key  of feed.reactionKeys">
            {{feed.reaction_count[key]}}{{key}},
          </span>
        </span>
      </ion-col>
      <ion-col size="2">
        <ion-badge color="medium" mode="ios" (click)="showEmojiBox=!showEmojiBox">Your Reaction</ion-badge>
      </ion-col>
    </ion-row>
    <div *ngIf="showEmojiBox==true" style="height:30vh; overflow: scroll;">
      <ion-row>
        <ion-col size="2" *ngFor="let emoji of reactionService.emojiList" class="font2"
          (click)="clickEmoji(emoji)">{{emoji}}</ion-col>
      </ion-row>
    </div>

    <!-- <ion-row>
      <ion-col size="4">23
        <ion-icon name="thumbs-up" color="warning" class="font1_5"></ion-icon></ion-col>
      <ion-col size="4" class="textCenter">
        <ion-icon name="heart" color="danger" class="font1_5"></ion-icon>
      </ion-col>
      <ion-col size="4" class="textRight">
        6 <ion-icon name="chatbubble-ellipses-outline" color="tertiary" class="font1_5"></ion-icon>
      </ion-col>
    </ion-row> -->
  </ion-card>
</ion-card>